module.exports = __webpack_public_path__ + "static/media/close-icon.8e8a539a.svg";